import MDEditor, { commands } from "@uiw/react-md-editor";
import { StyledEditor } from "./styles";

export default function Editor({
  value,
  onChange,
  error,
  helperText,
  sx,
  placeholder,
}: any) {
  

  return (
    <StyledEditor
      sx={{
        ...(error && {
          border: (theme) => `solid 1px ${theme.palette.error.main}`,
        }),
        ...sx,
      }}
    >
      <MDEditor
        value={value}
        onChange={onChange}
        preview="edit"
        textareaProps={{
          placeholder: placeholder,
          style: {
            backgroundColor: "#181A1D",
          },
          color: "#ffff00",
        }}
        style={{ backgroundColor: "#181A1D" }}
        commandsFilter={(command) => {
          // remove os que você não quer
          if (
            command.name === "image" ||
            command.name === "link" ||
            command.name === "comment" ||
            command.name === "help" ||
            command.name === "checked-list" ||
            command.name === "codeBlock"
          ) {
            return false;
          }
          return command;
        }}
        previewOptions={{
          style: {
            backgroundColor: "#181A1D",
          },
        }}
      />
      {helperText && helperText}
    </StyledEditor>
  );
}
